SNI.Application.addModule('mediastrip', context => {

  return {
    behaviors: ['lazy-load']
  };

});
